import React from 'react';

export default () => (
  <div className="loader">
    <img className="loader__image" src="https://s3-ap-southeast-1.amazonaws.com/app.thrifti.data/images/loader.gif" />
  </div>
);
